import { css } from '@emotion/core'

// The floating controls' height (11px padding x2 + 24px glyph) and the height
// of a top bar they can share (the tab bars of Where am I from, Compare Me,
// Famous Connections, and Record My Story).
export const EXPERIENCE_NAV_PILL_BLOCK_SIZE_CSS = '46px'
export const EXPERIENCE_NAV_TOP_BAR_BLOCK_SIZE_CSS = '64px'

const TABS_BLOCK_SIZE_CSS = '48px'

// Centers the controls on a top bar's row: set for the bar's lifetime by the
// experiences whose landing keeps one.
export const experienceNavTopBarPositionCss = css`
  :root {
    --experience-nav-block-start: calc(
      (${EXPERIENCE_NAV_TOP_BAR_BLOCK_SIZE_CSS} - ${EXPERIENCE_NAV_PILL_BLOCK_SIZE_CSS}) / 2
    );
  }
`

// Applies the shared bar size and reserves the start-side gutter published by
// ExperienceNavControls. Tabs bars use their natural 48px height plus padding;
// flex bars receive the fixed total height directly.
export const experienceNavTopBarCss = ({ padTabs = false } = {}) => css`
  ${
    padTabs
      ? `padding-block: calc((${EXPERIENCE_NAV_TOP_BAR_BLOCK_SIZE_CSS} - ${TABS_BLOCK_SIZE_CSS}) / 2);`
      : `height: ${EXPERIENCE_NAV_TOP_BAR_BLOCK_SIZE_CSS};`
  }
  padding-inline-start: var(--experience-nav-inline-clearance, 0px);
`
